/**
 * 该文件主要用于设置默认axios配置
 */
import axios from 'axios'
import config from '@/config'

axios.defaults.url = '/zxcity_restful/ws/rest'
axios.defaults.method = 'post'
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'
axios.defaults.headers.post['apikey'] = 'test'
axios.defaults.timeout = 5000
axios.defaults.responseType = 'json'

// 预处理请求数据
axios.defaults.transformRequest = function(data, headers) {
  var params = new URLSearchParams()
  for (const key in data) params.append(key, data[key])
  return params
}

// response过滤
axios.interceptors.response.use(function (res) {
  return res
}, function (err) {
  return Promise.reject(err)
})

// 封装axios，只需要传入cmd，JSON格式的参数就行
const request = (cmd, data) => {
  let instance = axios.create()
  return instance.request({
    data: {
      cmd,
      data: JSON.stringify(data),
      version: config.api.version
    }
  })
}
// 特殊情况下，可能还需要使用axios
export default {
  request,
  axios
}
